export default {
  DARK: {
    buttonShadow: () => 'none',
    raisedShadow: () => 'none'
  }
}
